<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { isMobile } from '../../../common/util';
  import { getAllImageSrcsets, separateMobileDesktopParamsFromString } from '../services/amplience';

  export let image: string;
  export let mobileImage: string = undefined;
  export let width: string = undefined;
  export let height: string = undefined;
  export let getAllResolutions: boolean = true;
  export let alt = '';
  export let imagePosition = 'center center';
  export let templateName = '';
  export let fetchpriority: 'high' | 'low' | 'auto' = 'auto';

  const isResponsive = isMobile();
  $: isAmplienceImage = image && !image.includes('windows.net');
  $: pictureSrcsets = image && getAllImageSrcsets(image, mobileImage, getAllResolutions, templateName, width, height);

  $: widthValueObj = (width?.length > 0 && separateMobileDesktopParamsFromString(width)) || null;
  $: lengthUnit = (width || height || []).includes('%') ? '%' : 'px';
  $: widthNumber =
    (!!widthValueObj && parseInt(isResponsive ? widthValueObj.mobile : widthValueObj.desktop)) || undefined;
  $: heightValueObj = (height?.length > 0 && separateMobileDesktopParamsFromString(height)) || null;
  $: heightNumber =
    (!!heightValueObj && parseInt(isResponsive ? heightValueObj.mobile : heightValueObj.desktop)) || undefined;
  let loaded = false;
  const dispatcher = createEventDispatcher();

  function onImageLoad(e) {
    loaded = true;
    dispatcher('load', e);
  }
</script>

<picture class:visible={loaded} style="--img-width:{widthNumber}{lengthUnit}; --img-height:{heightNumber}{lengthUnit}">
  {#if pictureSrcsets?.length > 0 && isAmplienceImage}
    {#each pictureSrcsets as { media, type, srcset }}
      <source {media} {type} {srcset} />
    {/each}
    <img
      width={widthValueObj && parseInt(isResponsive ? widthValueObj.mobile : widthValueObj.desktop)}
      height={heightValueObj && parseInt(isResponsive ? heightValueObj.mobile : heightValueObj.desktop)}
      fetchpriority={fetchpriority !== 'auto' ? fetchpriority : undefined}
      loading={fetchpriority === 'auto' ? 'lazy' : undefined}
      style={`object-position:${imagePosition}`}
      on:load={onImageLoad}
      src={pictureSrcsets[0].srcset}
      {alt}
    />
  {:else}
    <img
      width={widthValueObj && parseInt(isResponsive ? widthValueObj.mobile : widthValueObj.desktop)}
      height={heightValueObj && parseInt(isResponsive ? heightValueObj.mobile : heightValueObj.desktop)}
      fetchpriority={fetchpriority !== 'auto' ? fetchpriority : undefined}
      loading={fetchpriority === 'auto' ? 'lazy' : undefined}
      style={`object-position:${imagePosition}`}
      on:load={onImageLoad}
      src={image}
      {alt}
    />
  {/if}
</picture>

<style lang="scss">
  picture {
    visibility: hidden;
    opacity: 0;
    transition: opacity 250ms ease;

    img {
      width: var(--img-width, auto);
      height: var(--img-height, auto);
      aspect-ratio: auto;
      object-fit: contain;
      max-width: 100%;
      max-height: 100%;
    }

    &.visible {
      visibility: visible;
      opacity: 1;
    }
  }
</style>
